import { render } from "./LoaderComponent.vue?vue&type=template&id=ae16003e&scoped=true"
const script = {}

import "./LoaderComponent.vue?vue&type=style&index=0&id=ae16003e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ae16003e"]])

export default __exports__